import React from "react";
import Box from "./Box";
import posterGif from "../frank_poster1.gif";

export default function GifBox() {
  return (
    <Box
      backgroundColor="palegreen"
      borderColor="darkslateblue"
      title="I REALLY DO PRINT THEM, Y'ALL"
    >
      <div style={{ textAlign: "center" }}>
        <img src={posterGif} style={{ maxWidth: "100%", margin: "0 auto" }} />
        <div style={{ paddingTop: "0.25em", fontSize: "0.6em" }}>
          <a target="_blank" href="https://gifs.frank.dev">
            made on the great great website gifs.frank.dev
            <br />
            "where your dreams become gifs"
          </a>
        </div>
      </div>
    </Box>
  );
}
